import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

//import constants
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import validators
import { ValidateExtension } from '../../../../validators/extension.validator';

//import services
import { GeneralService } from '../../../../services/general.service';
import { EmployeeService } from '../../../../services/employee.service';
import { exit } from 'process';

declare var $: any;

@Component({
  selector: 'app-skills_analysis-create',
  templateUrl: './skills_analysis-create.component.html',
  styleUrls: ['./skills_analysis-create.component.css']
})
export class SkillsAnalysisComponent implements OnInit {

  @Input() deptId: string;
  @Input() analysisId: string;
  @Input() langs: string;

  @ViewChild('imagePreviewRef') imagePreviewRef: ElementRef;
  frequencyConfig: any;
  LevelCompetence: any;
  RepTypes: any;

  typeConfig: any;
  planConfig: any;
  emp_id: any;
  modalTitle: string;
  maintenance_plans: any;
  employee_skills: any;
  app_maintenance_plans: any;
  skills: any;
  skills_records: any;
  emp_skills: any;
  app_emp_id: any;
  lang: any;
  generalLang: any;
  record: any;
  mode: string;
  StatusData: any;

  imageLink: any;

  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;
  empployees:any;

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  constructor(
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private employeeService: EmployeeService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    console.log("ID===>"+this.deptId)
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };    
    this.FormBuild()
    this.getData();    
  }

  FormBuild(): void {
    this.createForm = this.formBuilder.group({
      skill_analysis_employees: ['', [Validators.required]],
      skill_analysis_description: ['', [Validators.required]],
      skill_analysis_date: ['', [Validators.required]],
      ref_id:[this.deptId],
      id:[this.analysisId],
      action: 'update_skills',
    });
  }

  onSubmit() {
    console.log(this.createForm.value); 
    // console.log(this.createForm.value); return false;
    this.createFormSubmitted = true;

    if (this.createForm.invalid)
      return;

      // console.log('test12'); return false;

    this.employeeService.addSkillAnaylsis(this.createForm.value).subscribe(
      res => {

        if (res.status) {
          this.generalService.notify_msg('success', res.msg);
          this.bsModalRef.hide();

          this.router.navigateByUrl('/test', { skipLocationChange: true })
            .then(() => {
              this.router.navigate([AppFrontRoutes.SKILLS_LIST]);
            });
        }
        else {
          this.generalService.notify_msg('error', res.msg);
          this.bsModalRef.hide();
        }

      }
    );
  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }

  getData() {
    this.employeeService.getSkillEmployees(this.analysisId,this.deptId)
        .subscribe(
          (res) => {
            const loca = res.data.employees
            this.lang = this.employeeService.createLang(res);
            const tempEmp = []
            const tempSelectedItems = []
            let selectedEmployees = (res.data.edit_data && res.data.edit_data.skills_anys_employees)?res.data.edit_data.skills_anys_employees:""
            selectedEmployees = selectedEmployees.split(",")
            Object.keys(loca).forEach(function (key) {
              if(selectedEmployees.indexOf(loca[key].employeeId)){
                tempSelectedItems.push({ item_id: loca[key].employeeId, item_text: loca[key].employee_name },)  
              }
              tempEmp.push({ item_id: loca[key].employeeId, item_text: loca[key].employee_name },)
            }); 
            this.dropdownList = tempEmp
            this.selectedItems = tempSelectedItems
            this.generalLang = this.langs;
            // if edit data has value, then prefill in form
            if(res.data.edit_data && this.analysisId){
              this.createForm.patchValue({
                "skill_analysis_description":res.data.edit_data.skill_analysis_description,
                "skill_analysis_date":res.data.edit_data.skill_analysis_date,
              })              
            }
          }
        );

        if(this.analysisId){
          this.mode = 'Edit';
          this.modalTitle = 'UPDATE SKILL ANALYSIS';

        }else{
          this.mode = 'Create';
          this.modalTitle = 'CREATE SKILL ANALYSIS';
        }            

    }
}
